<template>
  <div class="basic_wrap notice-detail-page">
    <div class="red_top_bg notice-top">
      <div
        class="back_left"
        @click="$router.back()"
      />
      <div class="big_tit">
        {{ $t('notice.detail') }}
      </div>
    </div>
    <div class="ctn notice-content">
      <!-- <vue-editor v-model="data.content" style="display: none"/> -->
      <article class="msg_box notice-card">
        <header class="tit notice-header">
          <h1 class="tips notice-title">
            {{ data[title] }}
          </h1>
          <p
            v-if="data.add_time"
            class="time notice-time"
          >
            {{ data.add_time }}
          </p>
        </header>
        <div
          class="contract_box notice-body"
          v-html="data[content]"
        />
      </article>
    </div>
  </div>
</template>

<script>
import Fetch from "../../utils/fetch";
// import {VueEditor} from 'vue2-editor'

export default {
	name: "NoticeArticle",
	/* components: {
		VueEditor
	}, */
	data() {
		return {
			title: "title" ,
			content: "content" ,
			data: {},
		};
	},
	created() {
		this.$parent.footer("user", false);
	},
	mounted() {
		this.start();
	},
	methods: {
		start() {
			Fetch("/user/notice_view", {
				id: this.$router.history.current.params.id,
			}).then(res => {
				this.data = res.data.view;
			});
		},
	},
};
</script>

<style lang="less" scoped>
.notice-detail-page {
	min-height: 100vh;
	padding-bottom: 80px;
	background: #f1f8f7;
	color: #123d42;
	box-sizing: border-box;
}

.notice-top {
	background: #063942;
	color: #fff;
	border-bottom: 1px solid #075e67;
	box-sizing: border-box;

	.back_left {
		opacity: 0.88;
	}

	.big_tit {
		max-width: 72%;
		color: #fff;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		word-break: normal;
	}
}

.notice-content {
	padding: 16px;
	box-sizing: border-box;
}

.notice-card {
	margin: 0;
	overflow: hidden;
	border-radius: 14px;
	border: 1px solid #c7e0dd;
	background: #fff;
	box-shadow: 0 8px 18px rgba(10, 73, 79, 0.08);
	box-sizing: border-box;
}

.notice-header {
	padding: 16px 18px 14px;
	background: #e8f5f3;
	border-bottom: 1px solid #c7e0dd;
	box-sizing: border-box;
}

.notice-title {
	margin: 0;
	color: #074b53;
	font-size: 16px;
	font-weight: 700;
	line-height: 22px;
	word-break: break-word;
}

.notice-time {
	margin: 8px 0 0;
	color: #60797c;
	font-size: 12px;
	line-height: 18px;
	word-break: break-word;
}

.notice-body {
	width: 100%;
	padding: 16px 18px 20px;
	color: #123d42;
	font-size: 14px;
	line-height: 22px;
	word-break: break-word;
	box-sizing: border-box;

	/deep/ * {
		max-width: 100%;
		color: inherit !important;
		background: transparent !important;
		box-sizing: border-box;
	}

	/deep/ p,
	/deep/ div {
		margin-top: 0;
		line-height: 22px;
	}

	/deep/ p {
		margin-bottom: 12px;
	}

	/deep/ img {
		display: block;
		max-width: 100%;
		height: auto;
		margin: 10px auto;
		border-radius: 8px;
	}

	/deep/ a {
		color: #087780 !important;
		text-decoration: underline;
	}

	/deep/ table {
		width: 100%;
		border-collapse: collapse;
		overflow: hidden;
	}

	/deep/ td,
	/deep/ th {
		padding: 8px;
		border: 1px solid #d7e9e7;
	}

	/deep/ ul,
	/deep/ ol {
		margin: 0 0 12px 20px;
		padding: 0;
	}
}

@media screen and (max-width: 374px) {
	.notice-content {
		padding-right: 12px;
		padding-left: 12px;
	}

	.notice-header,
	.notice-body {
		padding-right: 14px;
		padding-left: 14px;
	}
}
</style>
